import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { api, getToken } from "./lib/api";
import SignIn from "./pages/SignIn";
import Shell from "./components/Shell";
import Dashboard from "./pages/Dashboard";
import FeedbackList from "./pages/FeedbackList";
import FeedbackDetail from "./pages/FeedbackDetail";
import StaffList from "./pages/StaffList";
import StaffDetail from "./pages/StaffDetail";
import ReplyList from "./pages/ReplyList";
import ReplyDetail from "./pages/ReplyDetail";

/** Gates the app on a session that the SERVER agrees is valid.
 *
 *  Checking only for a token in localStorage would let a revoked or expired
 *  session render the whole shell and then fail every request inside it, which
 *  looks like the app is broken rather than like the user is signed out. */
function Gate({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<"checking" | "in" | "out">(
    getToken() ? "checking" : "out"
  );

  useEffect(() => {
    if (state !== "checking") return;
    api.auth
      .me()
      .then(() => setState("in"))
      .catch(() => setState("out"));
  }, [state]);

  if (state === "checking") return null;
  if (state === "out") return <Navigate to="/signin" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/signin" element={<SignIn />} />
      <Route
        path="*"
        element={
          <Gate>
            <Shell>
              <Inner />
            </Shell>
          </Gate>
        }
      />
    </Routes>
  );
}

function Inner() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/feedbacks" element={<FeedbackList />} />
      <Route path="/feedbacks/:id" element={<FeedbackDetail />} />
      <Route path="/staff" element={<StaffList />} />
      <Route path="/staff/:id" element={<StaffDetail />} />
      <Route path="/replies" element={<ReplyList />} />
      <Route path="/replies/:id" element={<ReplyDetail />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
